import { render } from "./NumberSelector.vue?vue&type=template&id=d64c62b0&scoped=true"
import script from "./NumberSelector.vue?vue&type=script&lang=js"
export * from "./NumberSelector.vue?vue&type=script&lang=js"

import "./NumberSelector.vue?vue&type=style&index=0&id=d64c62b0&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64c62b0"]])

export default __exports__